import { useEffect, useRef, useState } from "react";

interface UseMessageOverflowProps {
    initialExpanded?: boolean;
}

interface MessageOverflow {
    overflowRef: React.RefObject<HTMLDivElement | null>;
    isOverflowing: boolean;
    isExpanded: boolean;
    setIsExpanded: React.Dispatch<React.SetStateAction<boolean>>;
}

export function useMessageOverflow({ initialExpanded = false }: UseMessageOverflowProps = {}): MessageOverflow {
    const overflowRef = useRef<HTMLDivElement>(null);
    const [isOverflowing, setIsOverflowing] = useState(true);
    const [isExpanded, setIsExpanded] = useState(initialExpanded);

    useEffect(() => {
        setIsOverflowing(
            overflowRef.current?.scrollHeight
                ? overflowRef.current.scrollHeight > overflowRef.current.clientHeight
                : false,
        );
    }, [overflowRef.current?.scrollHeight, overflowRef.current?.clientHeight]);

    return {
        overflowRef,
        isOverflowing,
        isExpanded,
        setIsExpanded,
    };
}
